// extracted by mini-css-extract-plugin
export var measureBox = "_52-0";